export default "__VITE_ASSET__7ece71cc__"